import { render, staticRenderFns } from "./flex-element-smart.vue?vue&type=template&id=13ea4732&"
import script from "./flex-element-smart.vue?vue&type=script&lang=js&"
export * from "./flex-element-smart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports